import * as Separator from '@radix-ui/react-separator'
import { Link } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

import { Button } from '@/components/button'
import type { Publication } from '@/models/publications'

export interface OthersListProps {
  data: Publication[]
  variant: 'news' | 'letters'
  showMore?: boolean
  title: string
  column?: boolean
}

export function OthersList({
  variant,
  data,
  showMore,
  title,
  column,
}: OthersListProps) {
  const hasData = data && data.length > 0

  return (
    <div
      className={twMerge(
        'mb-8',
        variant === 'news' ? 'text-publication-news' : 'text-bios-500',
      )}
    >
      <div className="mb-5 flex justify-between border-b-2 border-white">
        <h1 className="rounded-t-lg border-white bg-white px-3 py-1 text-xl font-semibold">
          {title}
        </h1>
        {showMore && (
          <Button
            disabled={!hasData}
            variant="ghost"
            className="text-monochromatic-400 group content-center rounded-b-none"
            asChild={hasData}
          >
            {hasData ? (
              <Link to={`/more-publications/${variant}`}>Ver todas</Link>
            ) : (
              'Ver todas'
            )}
          </Button>
        )}
      </div>
      <div
        className={twMerge(
          'grid',
          column ? 'gap-5 lg:grid-cols-2 lg:gap-24' : '',
        )}
      >
        {data?.map((item) => (
          <div key={item.id_publicacao}>
            <Link
              to={`/publication/${item.id_publicacao}`}
              className="l line-clamp-2 text-xl font-bold lg:h-16 lg:text-2xl"
            >
              {item.titulo}
            </Link>
            <Separator.Root
              className={twMerge('mt-5 h-0.5 bg-white', column ? '' : 'mb-5')}
            />
          </div>
        ))}
      </div>
    </div>
  )
}
